import React from 'react';
import { Link } from 'react-router-dom';
import Card from 'react-bootstrap/Card';
import Table from 'react-bootstrap/Table';
import { InmateMergeHistory } from '@reliance/types/models/InmateMergeHistory';
import { formatCurrency } from '../../format/Currency';
import { formatDate } from '../../format/DateTime';

type MergeHistoryProps = {
  history: InmateMergeHistory[];
};

const MergeHistory: React.FC<MergeHistoryProps> = ({ history }) => {
  if (!history || history.length === 0) {
    return null;
  }

  return (
    <>
      <Card className="mb-3">
        <Card.Header className="bg-primary text-white">
          <strong>Merge History</strong>
        </Card.Header>
        <Card.Body>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Date Merged</th>
                <th>From Inmate</th>
                <th>Facility</th>
                <th>Messaging Balance</th>
                <th>AV Balance</th>
                <th>Contacts</th>
              </tr>
            </thead>
            <tbody>
              {history.map((entry) => (
                <tr key={entry.id}>
                  <td>{formatDate(entry.dateMerged, true)}</td>
                  <td>
                    {entry.fromInmate ? (
                      <Link to={`/inmates/view/${entry.fromInmate.id}`}>
                        {entry.fromInmate.firstName} {entry.fromInmate.lastName} (#{entry.fromInmate.account})
                      </Link>
                    ) : (
                      `Inmate #${entry.fromInmateId}`
                    )}
                  </td>
                  <td>
                    {entry.fromInmate?.facility ? (
                      <Link to={`/facilities/view/${entry.fromInmate.facility.id}`}>
                        {entry.fromInmate.facility.name}
                        {entry.fromInmate.facility.state ? ` (${entry.fromInmate.facility.state})` : ''}
                      </Link>
                    ) : (
                      'Unknown'
                    )}
                  </td>
                  <td>{formatCurrency(entry.messagingBalance * -1)}</td>
                  <td>{formatCurrency(entry.audioVideoBalance * -1)}</td>
                  <td>{entry.contactCount}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card.Body>
      </Card>
      <hr className="mb-3" />
    </>
  );
};

export default MergeHistory;
